import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from './ErrorPage';
import Surprise from './Surprise';

/**
 * Errore generico.
 */
const UnexpectedErrorPage = ({ asPage }) => (
  <ErrorPage
    image={<Surprise className="error-page__image" />}
    title="Ops... è successo un imprevisto."
    message={(
      <Fragment>
        A volte basta ricaricare la pagina.
        <br />
        Se invece continui a vedere questo messaggio invia un quesito all&apos;assistenza.
      </Fragment>
    )}
    asPage={asPage}
  />
);

UnexpectedErrorPage.propTypes = {
  /**
Indica se mostrare il componente "come pagina singola".

Se il componente deve essere inserito in una `Card`, `Modal` o altro, usare `asPage=false`.
  */
  asPage: PropTypes.bool,
};

UnexpectedErrorPage.defaultProps = {
  asPage: true,
};

export default UnexpectedErrorPage;
